// run_search_analyst's citations block (PLEX-6500): rd appends {json: {citations: {ids, edges,
// ids_omitted?, edges_omitted?}}} after the analyst's prose, listing the Plex IDs its answer
// cites and the evidence records behind them. Not Bedrock's own citations, which
// llm/citations.js handles (PLEX-6049).

/** The citations block of a tool result, or null when it has none (or an empty one). */
export const citationsFromToolResult = (toolResult) => {
  for (const item of toolResult?.content || []) {
    const citations = item?.json?.citations;
    if (citations && (citations.ids?.length || citations.edges?.length)) {
      return citations;
    }
  }
  return null;
};
